import React, { useEffect, useState, useRef } from "react";
import "../DoctorConsole.scss";
import axios from "axios";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  FormControl,
  MenuItem,
  ListItemText,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  StyledSelect,
  StyledInputLabel,
  StyledCheckbox,
  StyledSelectForPastRecords,
} from "../StyledComponents";
import RecordsPagination from "../Utils/RecordsPagination";
import { organizedArrayByHiTypes } from "../Utils/UtilsFunctions";
const PastVisits = ({
  patientData,
  careContextList,
  fhirArrayData,
  onSubmitFhirArray,
}) => {
  console.log("Patient Data from Past Visists Page", patientData);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [fhirArray, setFhirArray] = useState(null);
  const [s3BucketFhir, setS3BucketFhir] = useState(null);
  const [selectedContextForRetrieveFhir, setSelectedContextForRetrieveFhir] =
    useState([]);
  const handleSelectCareContextForRetrieveFhir = async (event) => {
    let selectedValues = event.target.value;

    const isDeselect =
      selectedValues.length < selectedContextForRetrieveFhir.length;

    console.log("Selected Values", selectedValues);
    if (selectedValues.includes("Select All")) {
      if (careContextList.length !== selectedContextForRetrieveFhir.length) {
        selectedValues = careContextList.map(
          (item) => item.care_context_reference
        );
      } else {
        selectedValues = [];
      }
    }
    setSelectedContextForRetrieveFhir(selectedValues);

    const fhirStringToJson = (fhirData) => {
      console.log("Fhir Data From Doctor's Console", fhirData);
      console.log("FhirData Length", fhirData.length);

      const newData = [];

      fhirData.forEach((entry) => {
        const parsedEntry = {};

        Object.entries(entry).forEach(([keyId, arrayValues]) => {
          //key id is something like FHIR with ID ab37cb91-7d05-4aab-b0d9-fa739dd54288,inside this we have array of objects for a particular resourseType like Composition,patient, Organization etc
          // console.log("Array values in Past Visit", arrayValues);
          //maybe value inside each resource type is not coming in js format so we are modifying it
          const parsedArray = arrayValues.map((item) => {
            const parsedItem = {};

            Object.entries(item).forEach(([innerKey, value]) => {
              parsedItem[innerKey] = value;
            });

            return parsedItem;
          });
          // console.log("ParsedArray", parsedArray);
          const composition = parsedArray.find((item) =>
            item.hasOwnProperty("Composition")
          );

          let key = "Display not found";

          if (composition) {
            const compositionSnomedCode =
              composition?.Composition?.code?.[0]?.code;

            switch (compositionSnomedCode) {
              case "440545006":
                key = "Prescription";
                break;
              case "721981007":
                key = "Diagnostic Report";
                break;
              case "371530004":
                key = "OP Consultation";
                break;
              case "373942005":
                key = "Discharge Summary";
                break;
              case "41000179103":
                key = "Immunization Record";
                break;
              case "419891008":
                key = "Record artifact";
                break;
              case "1156871006":
                key = "Wellness Record";
                break;
            }
          }

          parsedEntry[key] = parsedArray;
          const compositionDate = composition?.Composition?.date?.split("T")[0];

          const dateEntry = newData.find((item) => item[compositionDate]);
          console.log("date Entry in doctors console", dateEntry);
          if (dateEntry) {
            dateEntry[compositionDate].push(parsedEntry);
          } else {
            newData.push({ [compositionDate]: [parsedEntry] });
          }
        });
      });

      console.log("New S3 Bucket Before Modification", newData);
      return newData;
    };
    try {
      if (selectedValues.length > 0 && !isDeselect) {
        // Form the request body
        const requestBody = {
          carecontexts: selectedValues,
        };

        // Make the GET request using Axios
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_fhir_based_on_carecontexts_new/`,
          requestBody,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
              // Add other headers if needed
            },
          }
        );

        // Handle the response data
        console.log("API response For Retrieve Fhir:", response.data);
        if (response.data.Status === "completed") {
          const fhirArr = response.data.response_list;

          fhirArr.map((fhirData) => {
            const newData = fhirStringToJson(fhirData["fhir_data"]);
            fhirData["fhir_data"] = newData;
          });
          console.log("Parsed Fhir Array Doctor Console", fhirArr);

          setFhirArray(fhirArr);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle errors, e.g., display an error message to the user
    }
  };
  useEffect(() => {
    console.log("Fhir Array Data from PAst visit page", fhirArrayData);
    if (fhirArrayData !== null) {
      let selecetedValues = fhirArrayData.map((data) => data.care_context);
      console.log("Selected Values from Past visit", selecetedValues);
      setSelectedContextForRetrieveFhir(selecetedValues);
      setFhirArray(fhirArrayData);
    }
  }, [fhirArrayData]);
  //based on fhirarray modify data for 2nd phase
  useEffect(() => {
    if (fhirArray !== null) {
      // creating deep copy of the fhirArray so that if we change copiedArray then that should not be reflected in fhirArray
      console.log("copiedFhirArray", fhirArray);
      const copiedFhirArray = JSON.parse(JSON.stringify(fhirArray));

      const modifiedFhirArray = organizedArrayByHiTypes(copiedFhirArray);
      console.log("modifiedFhirArray", modifiedFhirArray);
      setS3BucketFhir(modifiedFhirArray);
    }
  }, [fhirArray]);
  const localFhirArray = useRef(fhirArray);
  useEffect(() => {
    localFhirArray.current = fhirArray;
  }, [fhirArray]);

  console.log("FhirArray from Past Visit Page", fhirArray);
  //cleanup useeffect to store fhirarray
  useEffect(() => {
    return () => {
      console.log("Local Fhir Array", localFhirArray.current);
      onSubmitFhirArray(localFhirArray.current);
    };
  }, []);
  console.log("Visit Purpose List from Past Visist Page", careContextList);

  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const formatDateComposition = (inputDate) => {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    function getOrdinalSuffix(n) {
      if (n >= 11 && n <= 13) {
        return "th";
      }
      switch (n % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    }

    const formattedDate = `${day}${getOrdinalSuffix(day)} ${month}, ${year}`;
    return formattedDate;
  };
  const formatDate = (visitDatetime) => {
    const formattedDate = new Date(visitDatetime);

    const day = String(formattedDate.getDate()).padStart(2, "0");
    const month = String(formattedDate.getMonth() + 1).padStart(2, "0"); // January is 0!
    const year = String(formattedDate.getFullYear()).slice(-2); // Extract the last two digits of the year

    let hours = formattedDate.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight
    const minutes = String(formattedDate.getMinutes()).padStart(2, "0");

    const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;

    console.log(formattedDateTime);
    return formattedDateTime;
  };
  const getTitleForCareContextHavingNoPastVisit = (refId) => {
    const careContext = careContextList.find(
      (cc) => cc.care_context_reference === refId
    );
    return `Date: ${formatDate(careContext.timestamp)}(
${careContext.display})`;
  };
  const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  return (
    <div>
      <>
        <FormControl fullWidth sx={{ marginBottom: "1rem" }}>
          <StyledInputLabel id="demo-simple-select-helper-label">
            Select Visit Purposes
          </StyledInputLabel>
          <StyledSelectForPastRecords
            sx={{
              backgroundColor: selectedContextForRetrieveFhir
                ? "#c6f9f7"
                : "#f5f5f5", // teal when selected, light gray when unselected
              color: selectedContextForRetrieveFhir ? "#142c86" : "#888", // blue when selected, gray when empty
            }}
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select"
            value={selectedContextForRetrieveFhir} // Value is bound to selectedContextForRetrieveFhir
            onChange={handleSelectCareContextForRetrieveFhir} // onChange event handler
            multiple // Allowing multiple selection
            label="Select Visit Purposes"
            renderValue={(selected) => {
              if (Array.isArray(selected)) {
                return selected
                  .map((value) => {
                    const selectedCareContext = careContextList.find(
                      (item) => item.care_context_reference === value
                    );
                    return selectedCareContext
                      ? selectedCareContext.description
                      : "";
                  })
                  .join(", ");
              } else {
                const selectedCareContext = careContextList.find(
                  (item) => item.care_context_reference === selected
                );
                return selectedCareContext
                  ? selectedCareContext.description
                  : "";
              }
            }}
            MenuProps={{
              disablePortal: true,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left",
              },
              PaperProps: {
                style: {
                  maxHeight: 200,
                  width: "auto",
                },
              },
            }}
          >
            {/* commented temporarily */}
            {/* <MenuItem
              // onClick={handleSelectAllCareContextForRetrieveFhir}
              value={"Select All"}
            >
              <StyledCheckbox
                checked={
                  selectedContextForRetrieveFhir.length ===
                  careContextList.length
                }
              />
              <ListItemText primary="Select All" />
            </MenuItem> */}
            {careContextList.map((item, index) => (
              <MenuItem
                key={index}
                value={item.care_context_reference}
                style={{ whiteSpace: "normal", wordBreak: "break-word" }}
              >
                <StyledCheckbox
                  checked={selectedContextForRetrieveFhir.includes(
                    item.care_context_reference
                  )}
                />
                {`${item.description} ${item.care_context_reference}`}
              </MenuItem>
            ))}
          </StyledSelectForPastRecords>
        </FormControl>
      </>
      <>
        {s3BucketFhir !== null && s3BucketFhir && s3BucketFhir.length > 0 ? (
          s3BucketFhir.map((visit, index) => {
            const flattenedRecords = visit["fhir_data"].flatMap((dateObject) =>
              Object.entries(dateObject).flatMap(([date, items]) =>
                items.flatMap((item) =>
                  Object.entries(item).map(([sectionName, sectionData]) => ({
                    sectionName,
                    sectionData,
                  }))
                )
              )
            );
            console.log("Flattened Records Past Visit", flattenedRecords);
            if (
              visit.past_visit.length > 0 &&
              visit.fhir_data.length > 0 &&
              !isEmptyObject(visit.fhir_data[0])
            ) {
              return (
                <Accordion
                  key={index}
                  className="outer-accordion"
                  defaultExpanded
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`visit-${index}-content`}
                    id={`visit-${index}-header`}
                    className="outer-accordion-summary"
                  >
                    <Typography className="accordion-section-title">
                      {visit.visit_detail}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {flattenedRecords.length > 0 ? (
                      <RecordsPagination records={flattenedRecords} />
                    ) : (
                      "No Data Received"
                    )}

                    {visit["past_visit"].length > 0 && (
                      <>
                        {visit["past_visit"][visit["past_visit"].length - 1]
                          .transcribe !== "" && (
                          <Accordion className="outer-accordion">
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={`transcribe-${index}-content`}
                              id={`transcribe-${index}-header`}
                              className="outer-accordion-summary"
                            >
                              <Typography className="accordion-section-title">
                                Transcription
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails
                              id={`transcribe-accordian-${index}`}
                            >
                              <div className="responsive-container">
                                <iframe
                                  src={`data:application/pdf;base64,${
                                    visit["past_visit"][
                                      visit["past_visit"].length - 1
                                    ].transcribe
                                  }#toolbar=0`}
                                  frameBorder="1"
                                  className="responsive-iframe"
                                ></iframe>
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        )}
                        {visit["past_visit"][visit["past_visit"].length - 1]
                          .summary !== "" && (
                          <Accordion className="outer-accordion">
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={`summary-${index}-content`}
                              id={`summary-${index}-header`}
                              className="outer-accordion-summary"
                            >
                              <Typography className="accordion-section-title">
                                Summary
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails id={`summary-accordian-${index}`}>
                              <div className="responsive-container">
                                <iframe
                                  src={
                                    visit["past_visit"][
                                      visit["past_visit"].length - 1
                                    ].summary
                                  }
                                  frameBorder="1"
                                  className="responsive-iframe"
                                ></iframe>
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        )}
                      </>
                    )}
                  </AccordionDetails>
                </Accordion>
              );
            } else {
              return (
                <Accordion
                  key={index}
                  className="outer-accordion"
                  defaultExpanded
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`visit-${index}-content`}
                    id={`visit-${index}-header`}
                    className="outer-accordion-summary"
                  >
                    <Typography className="accordion-section-title">
                      {visit.visit_detail}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {flattenedRecords.length > 0 ? (
                      <RecordsPagination records={flattenedRecords} />
                    ) : (
                      "No Data Received"
                    )}
                  </AccordionDetails>
                </Accordion>
              );
            }
          })
        ) : (
          <div
            style={{
              justifyContent: "center",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography color="#125386" fontWeight={500}>
              No Visit Purpose Selected
            </Typography>
          </div>
        )}
      </>
    </div>
  );
};

export default PastVisits;
